<script setup>
import { computed } from "vue";
import { useRoute } from 'vue-router';
import { useContactStore } from "@/stores/contactStore";

const route = useRoute();
const contactStore = useContactStore();
const emit = defineEmits(["edit", "delete"]);

const columns = [
  { sorter: false },
  {
    title: "Name",
    dataIndex: "name",
    key: "Name",
    sorter: { compare: (a, b) => (a.name || "").localeCompare(b.name || "") },
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "Email",
    sorter: { compare: (a, b) => (a.email || "").localeCompare(b.email || "") },
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "Phone",
    sorter: { compare: (a, b) => (a.phone || "").localeCompare(b.phone || "") },
  },
  {
    title: "Company",
    dataIndex: "company_name",
    key: "Company",
    sorter: {
      compare: (a, b) =>
        (a.company_name || "").localeCompare(b.company_name || ""),
    },
  },
  {
    title: "Owner",
    dataIndex: "owner",
    key: "Owner",
    sorter: {
      compare: (a, b) => {
        const oa = a.owner?.first_name || a.owner?.email || "";
        const ob = b.owner?.first_name || b.owner?.email || "";
        return oa.localeCompare(ob);
      },
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "Status",
    sorter: {
      compare: (a, b) => (a.status || "").localeCompare(b.status || ""),
    },
  },
  { title: "", key: "action", sorter: false },
];

const data = computed(() => contactStore.items || []);
const rowSelection = {
  onChange: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
};
</script>

<template>
  <a-table
    class="table thead-light dq-responsive-table"
    :columns="columns"
    :data-source="data"
    :loading="contactStore.loading"
    :row-selection="rowSelection"
    row-key="id"
    :pagination="false"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Name'">
        <div class="d-flex align-items-center file-name-icon">
          <div class="avatar avatar-md border avatar-rounded">
            <span
              class="d-flex align-items-center justify-content-center w-100 h-100"
            >
              {{
                (record.first_name?.[0] || "C") + (record.last_name?.[0] || "")
              }}
            </span>
          </div>
          <div class="ms-2">
            <h6 class="fw-medium mb-0">
             
               <router-link
                        :to="{
                          name: 'crm.contacts.details',
                          params: { id: record.id },
                        }"
                      >
                        {{ record.name }}
                      </router-link>
            </h6>
            <span class="fs-12 fw-normal">{{ record.job_title || "" }}</span>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'Owner'">
        <span>
          {{
            record.owner?.first_name
              ? record.owner.first_name + " " + (record.owner.last_name || "")
              : record.owner?.email || "-"
          }}
        </span>
      </template>

      <template v-else-if="column.key === 'Status'">
        <span
          :class="[
            'badge',
            'badge-xs',
            'd-inline-flex',
            'align-items-center',
            record.status === 'Active' ? 'badge-success' : 'badge-secondary',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.status }}
        </span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
           <router-link
                        :to="{
                          name: 'crm.contacts.details',
                          params: { id: record.id },
                        }"
                        class="me-2"
                        v-can="'Contact.Read'"
                      >
                        <i class="ti ti-eye"></i>
                      </router-link>
          <a
            href="javascript:void(0);"
            class="me-2"
            @click="$emit('edit', record)"
            v-can="'Contact.Edit'"
            ><i class="ti ti-edit"></i
          ></a>
          <a
            href="javascript:void(0);"
            class="me-2"
            @click="$emit('delete', record)"
            v-can="'Contact.Delete'"
            ><i class="ti ti-trash"></i
          ></a>
        </div>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-responsive-table .ant-table) {
    min-width: 980px;
  }

  :deep(.dq-responsive-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
